'use client';

import { ReactNode, useState } from 'react';

import { useRouter } from 'next/navigation';

import { getSelectedPlan } from '@/libs/plans';
import type { PlanCode } from '@/types/config';
import { cn } from '@/utils/utils';
import { createClientComponentClient } from '@supabase/auth-helpers-nextjs';

export default function ButtonCheckout({
  planCode,
  children,
  className,
}: {
  planCode: PlanCode;
  children?: ReactNode;
  className?: string;
}) {
  const [isLoading, setIsLoading] = useState(false);
  const router = useRouter();
  const plan = getSelectedPlan(planCode);

  const handleSelectPlan = async () => {
    setIsLoading(true);
    const destination = `/submit?plan=${plan.planCode}&mode=purchase`;
    const supabase = createClientComponentClient();
    const { data: { user } } = await supabase.auth.getUser();

    if (!user) {
      router.push(`/signin?returnTo=${encodeURIComponent(destination)}`);
      return;
    }

    router.push(destination);
  };

  return (
    <button
      type="button"
      className={cn(
        'editorial-button editorial-button-primary flex min-h-14 w-full items-center justify-center gap-2.5 px-6 py-4 text-base font-semibold',
        className
      )}
      onClick={handleSelectPlan}
      disabled={isLoading}
      aria-busy={isLoading}
    >
      {isLoading ? <span className="loading loading-spinner loading-sm" /> : (children || `Continue · $${plan.price.toFixed(2)}`)}
    </button>
  );
}
